export default "__VITE_ASSET__0303f3d4__"